Drupal.behaviors.accordions = {
  attach(context, settings) {
    once('accordions', 'html').forEach(function (element) {
      // Selectors
      const items = context.querySelectorAll('.js-accordion-item');
      const controls = context.querySelectorAll('.js-accordion__controls');
      // Classes
      const itemToggle = '.js-accordion-item__toggle';
      const itemState = 'data-accordion-expanded';
      const buttonState = 'aria-expanded';
      const processedClass = 'js-accordion-processed'; // Nueva clase para indicar elementos procesados

      // Variable para almacenar la referencia al acordeón abierto actualmente
      let currentAccordion = null;

      // Function para cerrar todos los acordeones excepto el proporcionado
      const closeOtherAccordions = (exceptItem) => {
        items.forEach((item) => {
          if (item !== exceptItem) {
            const button = item.querySelector(itemToggle);
            // eslint-disable-next-line no-use-before-define
            collapse(item, button);
          }
        });
      };

      // Function para abrir un acordeón y cerrar los demás
      const openAccordion = (item, button) => {
        closeOtherAccordions(item);
        currentAccordion = item;
        item.setAttribute(itemState, 'true');
        button.setAttribute(buttonState, 'true');
      };

      // Function para cerrar un acordeón
      const collapse = (item, button) => {
        item.setAttribute(itemState, 'false');
        button.setAttribute(buttonState, 'false');
        currentAccordion = null;
      };

      // Toggle accordion content when toggle is activated.
      items.forEach((item, index) => {
        const button = item.querySelector(itemToggle);

        // Verificar si el elemento ya ha sido procesado
        if (!item.classList.contains(processedClass)) {
          // Ocultar todas las secciones de contenido del
          // acordeón si JavaScript está habilitado.
          collapse(item, button);

          button.addEventListener('click', (event) => {
            event.preventDefault();
            console.log('clic');

            // Marcar el elemento como procesado
            item.classList.add(processedClass);

            // Alternar el estado del elemento.
            if (button.getAttribute(buttonState) === 'true') {
              collapse(item, button);
            } else {
              openAccordion(item, button);
            }
          });

          // Abrir automáticamente el primer acordeón al cargar la página
          if (index === 0) {
            openAccordion(item, button);
          }
        }
      });

      controls.forEach((control) => {
        // Obtener todos los elementos relevantes para el control.
        const allItems =
          control.parentNode.querySelectorAll('.js-accordion-item');
        // Agregar un listener de clic en el elemento <ul> padre.
        control.addEventListener('click', (e) => {
          // Determinar qué control se activó. `action` devolverá un
          // booleano. `true` si se hizo clic en el control de expansión,
          // de lo contrario, false.
          const action = e.target.classList.contains(
            'js-accordion__toggle-all--expand',
          );

          // Iterar sobre
          allItems.forEach((item) => {
            const button = item.querySelector(itemToggle);
            if (action === false) {
              collapse(item, button);
            } else {
              openAccordion(item, button);
            }
          });
        });
      });

      const accordions = document.querySelectorAll('.accordion-item__toggle');

      // Función para abrir acordeón según el hash
      function openAccordionByHash() {
        const hash = window.location.hash.substring(1); // Remueve el "#"

        if (!hash) return;

        accordions.forEach((button) => {

          // Obtén el texto del botón
          const sectionName = button.textContent
            .trim()
            .normalize('NFD') // Descompone caracteres acentuados
            .replace(/[\u0300-\u036f]/g, '') // Elimina marcas de acentuación
            .replace(/\s+/g, '-') // Reemplaza espacios por guiones
            .toLowerCase();

          if (sectionName === hash) {
            // Abre el acordeón
            const accordionItem = button.closest('.accordion-item');
            accordionItem.setAttribute('data-accordion-expanded', 'true');
            button.setAttribute('aria-expanded', 'true');
            accordionItem.querySelector(
              '.accordion-item__content',
            ).style.display = 'block';

            // Desplazamiento suave al acordeón
            accordionItem.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          } else {
            // Cierra los demás acordeones
            const accordionItem = button.closest('.accordion-item');
            accordionItem.setAttribute('data-accordion-expanded', 'false');
            button.setAttribute('aria-expanded', 'false');
            accordionItem.querySelector(
              '.accordion-item__content',
            ).style.display = 'none';
          }
        });
      }

      accordions.forEach((accordion) => {
        accordion.addEventListener('click', function () {
          // Encuentra el h2 padre del botón
          const heading = this.closest('.accordion-item').querySelector(
            '.accordion-item__heading',
          );

          // Obtén el texto dentro del h2 y límpialo
          const sectionName = heading.textContent
            .trim()
            .replace(/\s+/g, '-')
            .toLowerCase();

          // Actualiza el hash en la URL
          window.location.hash = sectionName;
        });
      });

      // Llamar a la función al cargar la página
      openAccordionByHash();

      // Vuelve a llamar si el hash cambia
      window.addEventListener('hashchange', openAccordionByHash);
    });
  },
};
